namespace Gamification.Gamification {
    export interface ProdottiAziendeForm {
        IdProdotto: Serenity.IntegerEditor;
        IdAzienda: Serenity.IntegerEditor;
    }

    export class ProdottiAziendeForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.ProdottiAziende';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProdottiAziendeForm.init)  {
                ProdottiAziendeForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;

                Q.initFormType(ProdottiAziendeForm, [
                    'IdProdotto', w0,
                    'IdAzienda', w0
                ]);
            }
        }
    }
}
